import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AdminProvider } from './context/AdminContext';
import Home from './pages/Home';
import Contact from './pages/Contact';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminInquiries from './admin/AdminInquiries';
import AdminCMS from './admin/AdminCMS';
import AdminMenuManager from './admin/AdminMenuManager';
import AdminCategoryManager from './admin/AdminCategoryManager';
import AdminSettings from './admin/AdminSettings';
import AllResources from './pages/AllResources';
import AllDetails from './pages/AllDetails';

import AOS from 'aos';
import 'aos/dist/aos.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100
    });
  }, []);

  return (
    <Router>
      <AdminProvider>
        <Toaster position="top-right" />
        <Routes>
          {/* ==================== PUBLIC ROUTES ==================== */}
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Resources Routes - Public */}
          <Route path="/resources" element={<AllResources />} />
          <Route path="/resource/:type/:id" element={<AllDetails />} />
          
          {/* ==================== ADMIN ROUTES ==================== */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="cms" element={<AdminCMS />} />
            <Route path="menu-manager" element={<AdminMenuManager />} />
            <Route path="categories" element={<AdminCategoryManager />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
      </AdminProvider>
    </Router>
  );
}

export default App;